import React, { FC } from 'react';
import './App.css';

import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import ApplicationProvider from 'inruta-commons/lib/application/ApplicationProvider';
import ApplicationData from 'inruta-commons/lib/application/ApplicationData';
import { createMuiTheme, ThemeProvider } from '@material-ui/core';
import { ApolloProvider } from '@apollo/client';
import OrdersPage from './pages/orders/OrdersPage';
import OrderDetailsPage from './pages/orderdetails/OrderDetailsPage';
import DashboardPage from './pages/dashboard/DasboardPage';
import CatalogsPage from './pages/productcatalog/CatalogsPage';
import CatalogSpecEditPage from './pages/productcatalog/CatalogSpecEditPage';
import Catalog from './pages/productcatalog/print/Catalog';
import AllProductsPage from './pages/products/AllProductsPage';
import ShippingRatesPage from './pages/shipping/ShippingRatesPage';
import ShippingCarriersPage from './pages/shipping/carriers/ShippingCarriersPage';
import ShippingRegionsPage from './pages/shipping/regions/ShippingRegionsPage';
import PricesheetsPage from './pages/pricesheets/PricesheetsPage';

import createInRutaClient from './hooks/clients/createInRutaClient';
import EditPricesheetPage from './pages/pricesheets/EditPricesheetPage';

// Create base theme
const baseTheme = createMuiTheme({
  palette: {
    primary: {
      main: '#DEDEDE',
    },
  },
  typography: {
    fontFamily: [
      '"Open Sans"',
      'Caveat',
      'Kulim Park',
      '"Segoe UI"',
      'Roboto',
    ].join(','),
  },
});

// Create app theme
const appTheme = createMuiTheme({
  palette: {
    primary: {
      main: '#0F4B8D',
    },
  },
});

const App: FC = () => {
  const client = createInRutaClient();
  const applicationData: ApplicationData = {
    logoImageUrl: 'https://res.cloudinary.com/dxaubvelx/image/upload/v1576735537/webassets/productcatalog/Yellow-White_loqi9t.png',
    onLogoImageClick: () => {
      // aHistory?.push("/");
    },
    materialUiBaseTheme: baseTheme as any,
    bottomLinks: [],
    bottomCopyright: {
      label: 'inruta',
      action: 'https://www.inruta.com',
    },
    appStyle: {
      topBarColor: '#0F4B8D',
      buttonBarColor: '#0F4B8D',
      minHeightSm: '50rem',
      minHeightMd: '50rem',
    },
  };

  return (
    <ApplicationProvider applicationData={applicationData}>
      <ThemeProvider theme={appTheme}>
        <ApolloProvider client={client}>
          <Router>
            <Switch>
              {/* Products, Catalogs & Pricesheets */}
              <Route path="/catalogs" render={() => <CatalogsPage />} />
              <Route path="/catalogspec/:catalogSpecId" render={() => <CatalogSpecEditPage />} />
              <Route path="/printer/catalog" render={() => <Catalog />} />
              <Route path="/products" render={() => <AllProductsPage />} />
              <Route path="/pricesheets" render={() => <PricesheetsPage />} />
              <Route path="/pricesheet/:pricesheetId" render={() => <EditPricesheetPage />} />
              {/* Shipping */}
              <Route path="/shipping/regions" render={() => <ShippingRegionsPage />} />
              <Route path="/shipping/carriers" render={() => <ShippingCarriersPage />} />
              <Route path="/shipping/rates" render={() => <ShippingRatesPage />} />
              {/* Orders */}
              <Route path="/order/:id" render={() => <OrderDetailsPage />} />
              <Route path="/orders" render={() => <OrdersPage />} />
              {/* Dashboard */}
              <Route path="/" render={() => <DashboardPage />} />
            </Switch>
          </Router>
        </ApolloProvider>
      </ThemeProvider>
    </ApplicationProvider>
  );
};

export default App;
